export default {
    SMALL: 800,
    MEDIUM: 1064,
    LARGE: 1420,
};
